export enum EducationDegreeEndpoints {
  FetchEducationDegrees = '/education-degrees',
}
